export default __webpack_public_path__ + "static/media/NIRMALAS.eec0184f.TTF";